export default __webpack_public_path__ + "static/media/twitter-icon.a5219882.png";